export const profile = {
  CITY_PLACEHOLDER: 'Ex: San José',
  DOCUMENT_PLACEHOLDER: 'X.XXXX.XXXX',
  PHONE_PLACEHOLDER: 'XXXX XXXX',
  Document: 'CI/DIMEX',
};
